// Viewport eligibility for feature tours.
//
// Centralized so callers (the auto-launch in RunnitBoard, the launcher icon
// visibility in RunnitsApp, anything else added later) can't drift from each
// other — one constant, one rule. Returning a $vuetify breakpoint object's
// flag rather than wrapping it lets callers stay declarative at the call site.

interface VuetifyBreakpointHost {
	breakpoint: { lgAndUp: boolean };
}

// The board tour highlights desktop-only UI (settings drawer, side panels,
// node toolbar) — none of those targets exist on mobile/tablet, so we skip
// the tour entirely below lg.
export const isFeatureTourEligibleViewport = (vuetify: VuetifyBreakpointHost): boolean => {
	return vuetify.breakpoint.lgAndUp;
};
